import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const FastLoadingEcommerceWebsitesInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Fast-loading E-commerce Websites in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Speed Up Your Sales</Subheading>}
        heading={
          <Heading>
            Fast-loading <span tw="text-primary-500">E-commerce Websites</span>{" "}
            in Al Barsha
          </Heading>
        }
        description={
          <Description>
            MilaajBrandset delivers fast-loading e-commerce websites in **Al
            Barsha**, optimized for speed to boost conversions and enhance user
            experience. Keep your customers engaged with lightning-fast online
            stores.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1580894908361-967195033215?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1601972599748-19fe5a7e756f?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1573164713988-8665fc963095?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Optimize Your Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Speed Matters</Subheading>}
        heading="High-Performance E-commerce Solutions"
        description="Our fast-loading stores keep customers coming back."
        cards={[
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Lightning Speed",
            description: "Pages load in under 2 seconds.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Higher Conversions",
            description: "50% less bounce rate with fast stores.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Optimized Tech",
            description: "Leverage CDN, caching, and minification.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure Performance",
            description: "Speed without compromising safety.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile-Optimized",
            description: "Fast on desktops and smartphones.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Al Barsha Experts",
            description: "Trusted local speed specialists.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Deliver</Subheading>}
        heading="Our Speed Optimization Process"
        description={
          <Description>
            We build blazing-fast e-commerce stores:
            <ul tw="mt-4 list-disc pl-6">
              <li>Analysis: Assess your site’s performance needs.</li>
              <li>Design: Create lightweight, responsive layouts.</li>
              <li>Development: Use optimized code and plugins.</li>
              <li>
                Optimization: Implement caching, CDN, and image compression.
              </li>
              <li>Testing: Verify sub-2-second load times.</li>
              <li>Support: Monitor and maintain speed post-launch.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1534120247760-c44c3e4a62f1?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1593642702821-c8da6771f0c6?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1620714223084-8fcacc6dfd8d?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Our Achievements</Subheading>}
        heading="Fast-loading Success in Al Barsha"
        description="Our optimized stores deliver results."
        cards={[
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Speed Gains",
            description: "Reduced load times by 60%.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Uplift",
            description: "Boosted conversions by 35%.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Praise",
            description: "94% satisfaction rate.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Speed?</Subheading>}
        heading="Fast-loading E-commerce Websites in Al Barsha"
        description={
          <Description>
            MilaajBrandset creates fast-loading e-commerce websites in Al Barsha
            to drive sales and retain customers. Contact us to supercharge your
            online store today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1564069114553-7215e1ff1890?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1574717024453-354056adc482?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
